var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "303.000000pt",
    height: "196.000000pt",
    viewBox: "0 0 303.000000 196.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,196.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1491 1741 c-1272 -189 -1465 -220 -1477 -236 -17 -23 -18 -47 -1 -66 13 -17 443 -353 489 -383 27 -17 32 -16 845 245 450 144 825 264 833 267 54 18 -85 -56 -726 -387 l-721 -372 -138 -332 c-129 -312 -137 -333 -123 -357 31 -55 47 -47 363 179 161 116 298 211 304 211 6 0 129 -107 274 -239 145 -131 276 -246 291 -256 20 -14 32 -15 49 -8 25 12 1268 1854 1275 1890 5 25 -29 63 -55 62 -10 -1 -677 -99 -1482 -218z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcsLogo);
export default __webpack_public_path__ + "static/media/ecs_logo.7bc222535ad54bb62d99b6d18c307090.svg";
export { ForwardRef as ReactComponent };